export default {
  title: "Vue Devex"
};
